module.exports = __webpack_public_path__ + "img/guangao04.7ccca2b4.png";